import { render, staticRenderFns } from "./RecaudacionArqueo.vue?vue&type=template&id=0123c6e0&scoped=true"
import script from "./RecaudacionArqueo.vue?vue&type=script&lang=ts"
export * from "./RecaudacionArqueo.vue?vue&type=script&lang=ts"
import style0 from "./RecaudacionArqueo.vue?vue&type=style&index=0&id=0123c6e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123c6e0",
  null
  
)

export default component.exports